import { render, staticRenderFns } from "./TotalEvaluationsVisibilityColumnTemplate.vue?vue&type=template&id=85dfbeea"
import script from "./TotalEvaluationsVisibilityColumnTemplate.vue?vue&type=script&lang=js"
export * from "./TotalEvaluationsVisibilityColumnTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports